/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Orderer_LabelInputs */

const vi_order_orderer_label = /** @type {(inputs: Order_Orderer_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người đặt`)
};

/**

* @param {Order_Orderer_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_orderer_label = /** @type {((inputs?: Order_Orderer_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Orderer_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_orderer_label(inputs)
});